export default "__VITE_ASSET__Dda87g8g__"